import * as React from 'react';
import styled from 'styled-components';
import InputGroup from '../inputGroup/InputGroup';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SInputGroupWrapInner = styled.div<{ error: boolean; disabled: boolean }>(({ theme, error, disabled }) => {
  const disabledStyle = disabled ? { opacity: 0.5 } : {};

  return {
    width: 'calc(100% - 2px)',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.grayWhite,
    borderRadius: theme.borderRadiusCommon,
    position: 'relative',
    '&:focus-within': {
      borderColor: theme.colors.light,
    },
    input: {
      color: theme.colors.primaryBackground,
    },
    ...disabledStyle,
  };
});

const SInputWrap = styled.div(({ theme }) => ({
  width: '100%',
  height: '100%',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '&:not(:first-of-type)': {
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      height: 'calc(100% - 20px)',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 1,
      backgroundColor: theme.colors.border,
    },
  },
}));

const SInput = styled.input(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.font.size.smallMedium2,
  boxSizing: 'border-box',
  color: theme.colors.primaryBackground,
  backgroundColor: 'transparent',
  borderWidth: 0,
  appearance: 'none',
  outline: 'none',
  padding: `${theme.spacing.medium}px 0px`,
  width: '100%',
  maxWidth: '100%',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  '&:invalid': {
    boxShadow: 'none',
  },
  '&::placeholder': {
    color: theme.colors.placeholderGray,
    fontSize: theme.font.size.smallMedium2,
  },
  '& .creditCardNumber-Error.empty': {
    display: 'none',
  },
}));

const SErrorMessage = styled.span(({ theme }) => ({
  fontWeight: theme.font.weight.light,
  position: 'absolute',
  fontSize: theme.font.size.smaller,
  left: -1,
  bottom: 6,
  color: theme.colors.error,
  width: 80,
}));

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface ICreditCardCVVProps {
  onFilled?: (verificationCode: string, name: string, e?: HTMLInputElement) => void;
  value: string;
  className?: string;
  cvvRef?: React.Ref<HTMLInputElement>;
}

type creditCardCVVState = {
  cvv: string;
  error: string;
};

export class CreditCardCVV extends React.Component<ICreditCardCVVProps, creditCardCVVState> {
  public static defaultProps = {
    className: '',
    value: '',
  };

  public state = {
    cvv: '',
    error: '',
  };

  public componentDidMount() {
    if (this.props.value) {
      this.setState(
        () => ({ cvv: this.props.value }),
        () => {
          this.validateCVV();
        }
      );
    }
  }

  private validateCVV = () => {
    if (this.state.cvv.length !== 3) {
      this.setState(() => ({ error: 'Invalid CVV' }));
      return false;
    }
    this.setState(() => ({ error: '' }));
    return true;
  };

  public handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    // this.setState({ ...this.state, [event.currentTarget.name]: '' });
    // if (this.props.onFilled) {
    //   this.props.onFilled('', 'cvv', event.target);
    // }
  };

  public handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const el = event.currentTarget;
    const aNumber = /^\d+$/.test(el.value);
    if (!aNumber) {
      const newValue = el.value.length <= 1 ? '' : el.value.slice(0, -1);
      this.setState({ ...this.state, cvv: newValue });
      this.props.onFilled(this.state.cvv, 'cvv', el);
    }
    this.validateCVV();
    if (this.state.cvv.length === 3 && /^\d+$/.test(this.state.cvv)) {
      if (this.validateCVV() && this.props.onFilled) {
        this.props.onFilled(this.state.cvv, 'cvv', el);
      }
    }
  };

  public handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const valueCandidate = event.currentTarget.value;

    if (valueCandidate.length <= 3) {
      this.setState({ ...this.state, cvv: valueCandidate });
    }
  };

  public render() {
    return (
      <InputGroup className={this.props.className} dataAt="cvvInputGroup">
        <SInputGroupWrapInner error={Boolean(this.state.error)} disabled={false}>
          <SInputWrap>
            <SInput
              name="cvv"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={3}
              onFocus={this.handleFocus}
              onBlur={this.validateCVV}
              onKeyUp={this.handleKeyUp}
              value={this.state.cvv}
              onChange={this.handleChange}
              data-at="creditCardCvv"
              placeholder="cvv"
              data-testid="credit-card-cvv-input"
              ref={this.props.cvvRef}
            />
          </SInputWrap>
        </SInputGroupWrapInner>
        <SErrorMessage>{this.state.error}</SErrorMessage>
      </InputGroup>
    );
  }
}
